// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"bfed2633","165":"91104564","271":"bb7a3e17","304":"4cdce8e4","439":"93c93226","473":"51c3d221","536":"3f48115c","609":"0d7b4d9d","926":"3bb2a8a5","932":"a43462fc","938":"70313487","956":"d0a1c3b5"}[chunkId] + ".chunk.js";
};